import type {
  DataFilterDefinitionsDtoResponse,
  DataTableDataSearchDto,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export type TableFilterQueryKey = readonly [
  widgetId: string,
  pageFilterSelections: DataTableDataSearchDto['selection'],
  tableFilterSelections: DataTableDataSearchDto['selection'],
  ...string[],
];

export const fetchTableFilterData: QueryFunction<
  DataFilterDefinitionsDtoResponse,
  QueryKeyWithRole<TableFilterQueryKey>
> = async ({ queryKey }) => {
  const [widgetId, pageFilterSelections, tableFilterSelections] =
    unwrapQueryKeyWithRole(queryKey).params;

  const response = await portalGatewayClient.table.searchTableFilterData(
    widgetId,
    { selection: { ...pageFilterSelections, ...tableFilterSelections } }
  );

  if (!response.ok) {
    throw new Error(extractErrorMessage(response.error));
  }

  return response.data;
};
